module.exports = __webpack_public_path__ + "img/Sicilija.acfe5455.png";